import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import React from 'react';
import AddToCalendarHOC, { SHARE_SITES } from 'react-add-to-calendar-hoc';

import Button from '../../../../components/Button';
import { IEventItem } from '../../../../store/player/events/store';

interface IProps {
  item: IEventItem;
  onContinue: () => void;
  onCancel: () => void;
}

const AddToCalendarDropdown = AddToCalendarHOC(Button, MenuList);

const EventSuccess = ({ item, onCancel, onContinue }: IProps) => {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const startDate = moment(item.start).utc();
  const endDate = moment(item.end).utc();
  const duration = moment
    .duration(endDate.diff(startDate))
    .asHours()
    .toString();
  const location =
    typeof item.club !== 'number' ? item.club.course.address.replace(/\n|\r/g, '') : '';
  const event = {
    description: item.description || '',
    duration,
    endDatetime: endDate.format('YYYYMMDDTHHmmssZ'),
    location,
    startDatetime: startDate.format('YYYYMMDDTHHmmssZ'),
    title: item.name || ''
  };

  const isInWaitlist = item.enrollment && item.enrollment.status === 'waiting';

  const { cardTitle, cardSubtitle, cardHeadline } = isInWaitlist
    ? {
        cardHeadline: `This event happens to be full. You will be in line for a spot should another
          player withdraw. The waitinglist is created in the order the requests are received.
          Fingers crossed you get in.`,
        cardSubtitle: 'YOU’RE ON THE WAITLIST ',
        cardTitle: 'SIGNUP COMPLETED'
      }
    : {
        cardHeadline: `You’re all set to play in the event. If you need to withdraw go to events
          section, select this event, and click withdraw, or check with the head of your club.`,
        cardSubtitle: 'CONGRATS! YOU’RE IN!',
        cardTitle: 'SUCCESS'
      };

  return (
    <div className="event-checkout wrapper">
      <div className="event-success">
        <Paper elevation={1} className="paper">
          <h4>{cardTitle}</h4>

          <h3>{cardSubtitle}</h3>
          <div className="paragraph">{cardHeadline}</div>

          <Button
            variant="contained"
            color="primary"
            className="button"
            onClick={onContinue}
            id="success-leave-note"
          >
            LEAVE NOTE TO THE EVENT DIR.
          </Button>

          <AddToCalendarDropdown
            className="calendar-button-container"
            buttonProps={{
              className: 'button button-shadow',
              color: 'primary',
              id: 'success-continue',
              variant: 'outlined'
            }}
            dropdownProps={{
              className: 'button calendar-dropdown-container'
            }}
            buttonText="Add to calendar"
            event={event}
            items={
              isiOS
                ? [SHARE_SITES.GOOGLE, SHARE_SITES.ICAL, SHARE_SITES.YAHOO]
                : [SHARE_SITES.GOOGLE, SHARE_SITES.ICAL, SHARE_SITES.OUTLOOK, SHARE_SITES.YAHOO]
            }
          />

          <Button color="primary" className="button" onClick={onCancel} id="success-cancel">
            BACK TO CLUB HOME
          </Button>
        </Paper>
      </div>
    </div>
  );
};

export { EventSuccess };
